import * as constants from './constants';
import * as slice from './slice';
import sagas from './saga';

const productService = { constants, slice, sagas };

export default productService;

